import ReactLoadingSkeleton from 'react-loading-skeleton';
import { tv } from 'tailwind-variants';

import clsxm from '../utils/style';

import { FlexContainer } from './FlexContainer';

import type { SkeletonProps as ReactLoadingSkeletonProps } from 'react-loading-skeleton';

export type SkeletonProps = Pick<
  ReactLoadingSkeletonProps,
  'width' | 'height' | 'circle' | 'borderRadius' | 'count' | 'inline' | 'className' | 'containerClassName' | 'style'
>;

export interface SkeletonStackProps {
  lines: number | readonly Pick<SkeletonProps, 'width' | 'height'>[];
  gap?: 1 | 2 | 3;
  className?: string;
}

const skeletonStack = tv({
  variants: {
    gap: {
      1: 'gap-1',
      2: 'gap-2',
      3: 'gap-3',
    },
  },
  defaultVariants: {
    gap: 2,
  },
});

export function Skeleton(props: SkeletonProps) {
  return <ReactLoadingSkeleton {...props} />;
}

export function SkeletonStack({ lines, gap = 2, className }: SkeletonStackProps) {
  const skeletonLines = typeof lines === 'number' ? Array.from({ length: lines }, () => ({})) : lines;

  return (
    <FlexContainer className={clsxm(skeletonStack({ gap }), className)} direction="column" items="stretch">
      {skeletonLines.map((line, index) => (
        <Skeleton height={16} key={index} width="100%" {...line} />
      ))}
    </FlexContainer>
  );
}
